'use client';

import { useEffect } from 'react';

type Props = {
  loyaltyUserInfo: string | undefined;
};

const SaveLoyaltyUserToLocalStorage = ({ loyaltyUserInfo }: Props) => {
  useEffect(() => {
    if (loyaltyUserInfo) {
      localStorage.setItem('loyaltyUserInfo', loyaltyUserInfo);
    } else {
      localStorage.removeItem('loyaltyUserInfo');
    }
  }, [loyaltyUserInfo]);
  return null;
};

export default SaveLoyaltyUserToLocalStorage;
